export const DEFAULT_OBSERVER_OPTIONS = {
  threshold: 0,
  triggerOnce: true
};
